/**
 * @file コンポーネント：利用規約英語 スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledTerms = styled.article`
    padding: 16px;
    counter-reset: section;

    h3 {
        margin-bottom: 8px;
        color: #000000;
        font-size: 13px;
        line-height: 1.5;
    }

    h4 {
        margin-bottom: 8px;
        color: #000000;
        font-size: 12px;
        line-height: 1.5;

        &::before {
            counter-increment: section;
            content: "Article " counter(section) " (";
        }

        &::after {
            content: ")";
        }
    }

    ol {
        margin-left: 2em;

        > li {
            list-style-type: decimal;
            color: #000000;
            font-size: 11px;
            line-height: 1.5;
        }

        &[data-hierarchy="second"] {
            counter-reset: list;

            > li {
                list-style-type: none;

                &::before {
                    margin-right: 4px;
                    counter-increment: list;
                    content: "(" counter(list) ")";
                }
            }
        }
    }

    p {
        margin-bottom: 8px;
        color: #000000;
        font-size: 11px;
        line-height: 1.5;
    }

    section {
        margin-bottom: 16px;
    }

    ul {
        margin-left: 2em;

        > li {
            list-style-type: disc;
            color: #000000;
            font-size: 11px;
            line-height: 1.5;
        }
    }

    &[data-on-color="main"] {
        h3 {
            color: #ffffff;
        }

        h4 {
            color: #ffffff;
        }

        ol {
            > li {
                color: #ffffff;
            }
        }

        p {
            color: #ffffff;
        }

        ul {
            > li {
                color: #ffffff;
            }
        }
    }
`;
